export const ChevronDown = ({...rest}) => {
  const style = {fill: 'currentColor', maxWidth: '100%', maxHeight: '100%'};
  return (
    <div {...rest}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path
          d="M3.86863 7.86865C4.49347 7.24381 5.50653 7.24381 6.13137 7.86865L12 13.7373L17.8686 7.86865C18.4935 7.24381 19.5065 7.24381 20.1314 7.86865C20.7562 8.49349 20.7562 9.50656 20.1314 10.1314L13.1314 17.1314C12.5065 17.7562 11.4935 17.7562 10.8686 17.1314L3.86863 10.1314C3.24379 9.50656 3.24379 8.49349 3.86863 7.86865Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}